const maxDate = new Date().toISOString().slice(0, 10);
const minDate = `${+maxDate.slice(0, 4) - 100}${maxDate.slice(4)}`;

export default [
  [
    {
      name: 'firstName',
      required: true,
      width: 100
    },
    {
      name: 'lastName',
      required: true,
      width: 100
    },
    {
      pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
      required: true,
      name: 'email',
      type: 'email',
      width: 100
    },
    {
      pattern: /^(\+31[1-9]{9}$)|^([0-9]{10}$)/,
      name: 'phoneNumber',
      required: true,
      type: 'tel',
      width: 100
    },
    {
      name: 'dateBirth',
      required: true,
      type: 'date',
      min: minDate,
      max: maxDate,
      width: 100
    },
    {
      required: true,
      type: 'select',
      name: 'size',
      width: 100,
      options: [
        {
          name: 'XXS',
          value: 'xxs'
        },
        {
          name: 'XS',
          value: 'xs'
        },
        {
          name: 'S',
          value: 's'
        },
        {
          name: 'M',
          value: 'm'
        },
        {
          name: 'L',
          value: 'l'
        },
        {
          name: 'XL',
          value: 'xl'
        },
        {
          name: 'XXL',
          value: 'xxL'
        }
      ]
    },
    {
      type: 'textarea',
      required: false,
      name: 'message',
      maxLength: 250,
      width: 100,
      rows: 20
    }
  ],
  [
    {
      pattern: /^[0-9]{4}\s?[a-zA-Z]{2}$/,
      name: 'postalCode',
      required: true,
      width: 100
    },
    {
      name: 'houseNumber',
      pattern: /^\d+$/,
      required: true,
      width: 48
    },
    {
      pattern: /^[a-zA-Z0-9]{1,5}$/,
      name: 'suffix',
      width: 48
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      name: 'streetName',
      required: true,
      width: 100
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      required: true,
      name: 'venue',
      width: 100
    }
  ]
] as const;
